<template>
  <v-dialog
    v-model="open"
    max-width="60%"
  >
    <v-card id="importFile" ref="importFileModal">
      <v-card-title class="headline">
        Импортиране на файл
      </v-card-title>
      <v-card-text class="pt-10">
        <v-row>
          <v-col cols="12">
            <v-file-input
              accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              label="Импорт на артикули"
              v-model="data.excelFile"
              @change="uploadFile"
            ></v-file-input>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          @click="open = false"
        >
          Затвори
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'importFileModal',
  data(){
    return {
      open: false,
      data: {
        excelFile: null,
      },
    }
  },
  computed: {},
  mounted(){},
  methods: {
    openModal(){
      this.open = true;
    },
    closeModal(){
      this.open = false;
      this.data.excelFile = null;
    },
    uploadFile(){
      this.$emit('uploadFile', this.data);
    }
  }
}
</script>